<template>
  <div class="h-full">
    <button
      @click="modalIsActive = true"
      class="border-ontick-steel-200 dark:border-ontick-steel-600 dark:bg-ontick-steel-700 h-full items-center rounded-lg border bg-gray-200 px-2 text-sm font-medium text-gray-400 focus:outline-none"
    >
      <i v-html="$icons.settings"></i>
    </button>
    <portal to="modal">
      <ontick-modal-component
        :open="modalIsActive"
        @close="modalIsActive = false"
        class="text-gray-300"
      >
        <div class="space-y-4">
          <p class="border-ontick-steel-500 border-b-2 pb-4 text-2xl font-bold">
            Colunas
          </p>
          <div class="space-y-2">
            <div
              class="flex items-center space-x-4"
              v-for="column in optionalHeaders"
              :key="column.key"
            >
              <input
                type="checkbox"
                :id="column.key"
                class="border-ontick-blue-600 text-ontick-blue-600 ring-ontick-red-600 h-4 w-4 appearance-none rounded border-2 bg-transparent dark:border-gray-300"
                v-model="activeColumns"
                :value="column.key"
                :name="column.label"
              />
              <label
                :for="column.label"
                class="text-ontick-carbon-900 text-sm font-bold dark:text-gray-300"
              >
                {{ column.label }}
              </label>
            </div>
          </div>
          <ontick-button-component @click.native="selectColumns">
            Confirmar
          </ontick-button-component>
          <!-- <span>
            {{ activeColumns }}
          </span> -->
        </div>
      </ontick-modal-component>
    </portal>
  </div>
</template>

<script>
import OntickModalComponent from "@/app/shared/components/basic/ontick-modal.component.vue";
import OntickButtonComponent from "../../../../shared/components/basic/ontick-button.component.vue";
import EventBus from "@/app/shared/utils/event_bus.js";
import headers from "./new-list-view/headers";

export default {
  components: {
    OntickModalComponent,
    OntickButtonComponent,
  },

  data() {
    return {
      modalIsActive: false,
      activeColumns: [],
      defaultColumns: ["strategy_timeframe"],
    };
  },

  computed: {
    optionalHeaders() {
      return headers.filter((item) => item.optional);
    },
  },

  methods: {
    selectColumns() {
      localStorage.setItem("listModeColumns", this.activeColumns);
      EventBus.$emit("UPDATE_LIST_COLUMNS", this.activeColumns);
      this.modalIsActive = false;
    },
  },

  mounted() {
    const getLocalStorage = localStorage.getItem("listModeColumns");
    if (getLocalStorage) {
      this.activeColumns = getLocalStorage.split(",");
      EventBus.$emit("UPDATE_LIST_COLUMNS", this.activeColumns);
    } else {
      localStorage.setItem("listModeColumns", this.defaultColumns);
      EventBus.$emit("UPDATE_LIST_COLUMNS", this.defaultColumns);
      this.activeColumns = this.defaultColumns;
    }
  },
};
</script>

<style></style>
